export const orderedBCDPlusSlices: string[] = ['B', 'D', 'C', '3D'];
export const orderedBCDASlices: string[] = ['B', 'D', 'C', 'A'];
